export const EVENT_444_PHONE_VALIDATION = '444::PhoneValidation';
export const EVENT_444_BANNER_CLICK = '444::BannerClick';
